import Box from '@mui/material/Box';
import { Drawer } from '@openx/components-core/lib/Drawer/Drawer.tsx';
import { DrawerActionBar, type DrawerActions } from '@openx/components-core/lib/Drawer/DrawerActionBar.tsx';
import { DrawerHeader } from '@openx/components-core/lib/Drawer/DrawerHeader.tsx';
import { type JSX, type ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type TargetingDrawerProps = {
  name: string | JSX.Element;
  onClose: () => void;
  onApply: () => void;
  children: ReactNode;
  isApplyDisabled: boolean;
};

export const TargetingDrawer = ({
  onClose,
  onApply,
  name,
  children,
  isApplyDisabled,
}: TargetingDrawerProps): JSX.Element => {
  const { t } = useTranslation();

  const actions: DrawerActions = useMemo(
    () => [
      {
        color: 'primary',
        disabled: isApplyDisabled,
        label: t('Apply'),
        onClick: onApply,
      },
      {
        label: t('Cancel'),
        onClick: onClose,
        variant: 'text',
      },
    ],
    [isApplyDisabled, onApply, onClose, t]
  );

  return (
    <Drawer open onClose={onClose}>
      <Box data-test="side-details">
        <DrawerHeader onClose={onClose} sx={{ mb: 0 }}>
          {name}
        </DrawerHeader>
        {children}
        <DrawerActionBar actions={actions} stickyBottom hideDivider />
      </Box>
    </Drawer>
  );
};
